import React, { useState } from "react";
import {
  Box,
  Typography,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material";
import { AdminFeBaseMasterComponent } from "../../Pages/adminMgmt/feAdminMgmt/feBaseAdminComponent";
import { AdminFEAnualAccountOperationComponent } from "../../Pages/adminMgmt/feAdminMgmt/feAnualReportComponent";
import { AdminBussinessTypeMasterComponent } from "../../Pages/adminMgmt/feAdminMgmt/feBussinessType";
import { AdminChargeSheetMasterComponent } from "../../Pages/adminMgmt/feAdminMgmt/feChargeSheet";
import { AdminFeAuditReportMasterComponent } from "../../Pages/adminMgmt/feAdminMgmt/feAuditReports";
import { AdminFeBankAccountsMasterComponent } from "../../Pages/adminMgmt/feAdminMgmt/feBankAccounts";
import { AdminFeBussinessPremMasterComponent } from "../../Pages/adminMgmt/feAdminMgmt/feBusinessPrem";
import { AdminFeCapitalContributionMasterComponent } from "../../Pages/adminMgmt/feAdminMgmt/feCapitalContribution";
import { AdminFeCodeMasterComponent } from "../../Pages/adminMgmt/feAdminMgmt/feCodeComponent";
import { AdminFeCourtCasesMasterComponent } from "../../Pages/adminMgmt/feAdminMgmt/feCourtCases";
import { AdminFeOfficialsMasterComponent } from "../../Pages/adminMgmt/feAdminMgmt/fe_officials";
import { AdminFePersonalPropertiesMasterComponent } from "../../Pages/adminMgmt/feAdminMgmt/fePersonalProperties";
import { AdminFePropertyHoldingsComponent } from "../../Pages/adminMgmt/feAdminMgmt/fe_property_holdings";
import { AdminFeSiblingCompanyMasterComponent } from "../../Pages/adminMgmt/feAdminMgmt/feSiblings";
import { AdminFeValidityMasterComponent } from "../../Pages/adminMgmt/feAdminMgmt/feValidity";
import { AdminFirMasterComponent } from "../../Pages/adminMgmt/feAdminMgmt/adminFir";
import { AdminFraudulentSchemeMasterComponent } from "../../Pages/adminMgmt/feAdminMgmt/adminFraudulentScheme";
import { AdminFeDocsMasterComponent } from "../../Pages/adminMgmt/feAdminMgmt/feDocsComponenet";
import { AdminLegecyMasterComponent } from "../../Pages/adminMgmt/feAdminMgmt/adminLegecy";
import { AdminFeCAComponent } from "../../Pages/adminMgmt/feAdminMgmt/adminCaMgmt";
import { AdminFeVer1Component } from "../../Pages/adminMgmt/feAdminMgmt/adminVer1Component";
import { AdminFeVer2Component } from "../../Pages/adminMgmt/feAdminMgmt/adminVer2Component";
import { AdminSuperStaffComponent } from "../../Pages/adminMgmt/feAdminMgmt/adminFESuperStaffComponent";
import { AdminSherastedarComponent } from "../../Pages/adminMgmt/feAdminMgmt/feSherastadarComponent";
import { AdminPublicRecordCaseWorkerComponent } from "../../Pages/adminMgmt/feAdminMgmt/adminPublicCaseWorker";
import { AdminWarrantCaseWorkerComponent } from "../../Pages/adminMgmt/feAdminMgmt/adminWarrantCaseworker";
import { AdminFeForensicAuditorComponent } from "../../Pages/adminMgmt/feAdminMgmt/adminForensicAudComponent";
import { AdminFeRoleMasterComponent } from "../../Pages/adminMgmt/feAdminMgmt/adminACJSLegalFEMgmt";
import {
  AdminFeAcMgmt,
  AdminFeJsmgmt,
  AdminFeLegalMgmt,
  AdminFETahsildarMgmt,
} from "../../Pages/adminMgmt/feAdminMgmt/feAdminAcmgmt";

const FeMenuDropdownComponent = () => {
  const [selectedOption, setSelectedOption] = useState("");

  const handleChange = (event) => {
    setSelectedOption(event.target.value);
  };

  const renderComponent = () => {
    switch (selectedOption) {
      case "A":
        return (
          <Box>
            <AdminFeBaseMasterComponent />
          </Box>
        );
      case "B":
        return (
          <Box>
            <AdminFEAnualAccountOperationComponent />
          </Box>
        );
      case "C":
        return (
          <Box>
            <AdminBussinessTypeMasterComponent />
          </Box>
        );
      case "D":
        return (
          <Box>
            <AdminChargeSheetMasterComponent />
          </Box>
        );
      case "E":
        return (
          <Box>
            <AdminFeAuditReportMasterComponent />
          </Box>
        );
      case "F":
        return (
          <Box>
            <AdminFeBankAccountsMasterComponent />
          </Box>
        );
      case "G":
        return (
          <Box>
            <AdminFeBussinessPremMasterComponent />
          </Box>
        );
      case "H":
        return (
          <Box>
            <AdminFeCapitalContributionMasterComponent />
          </Box>
        );
      case "I":
        return (
          <Box>
            <AdminFeCodeMasterComponent />
          </Box>
        );
      case "J":
        return (
          <Box>
            <AdminFeCourtCasesMasterComponent />
          </Box>
        );
      case "K":
        return (
          <Box>
            <AdminFeOfficialsMasterComponent />
          </Box>
        );
      case "L":
        return (
          <Box>
            <AdminFePersonalPropertiesMasterComponent />
          </Box>
        );
      case "M":
        return (
          <Box>
            <AdminFePropertyHoldingsComponent />
          </Box>
        );
      case "N":
        return (
          <Box>
            <AdminFeSiblingCompanyMasterComponent />
          </Box>
        );
      case "O":
        return (
          <Box>
            <AdminFeValidityMasterComponent />
          </Box>
        );
      case "P":
        return (
          <Box>
            <AdminFirMasterComponent />
          </Box>
        );
      case "Q":
        return (
          <Box>
            <AdminFraudulentSchemeMasterComponent />
          </Box>
        );
      case "R":
        return (
          <Box>
            <AdminFeDocsMasterComponent />
          </Box>
        );
      case "S":
        return (
          <Box>
            <AdminLegecyMasterComponent />
          </Box>
        );
      case "T":
        return (
          <Box>
            <AdminFeCAComponent />
          </Box>
        );
      case "U":
        return (
          <Box>
            <AdminFeVer1Component />
          </Box>
        );
      case "V":
        return (
          <Box>
            <AdminFeVer2Component />
          </Box>
        );
      case "W":
        return (
          <Box>
            <AdminSuperStaffComponent />
          </Box>
        );
      case "X":
        return (
          <Box>
            <AdminSherastedarComponent />
          </Box>
        );

      case "Y":
        return (
          <Box>
            <AdminPublicRecordCaseWorkerComponent />
          </Box>
        );
      case "Z":
        return (
          <Box>
            <AdminWarrantCaseWorkerComponent />
          </Box>
        );
      case "AA":
        return (
          <Box>
            <AdminFeForensicAuditorComponent />
          </Box>
        );

      case "AB":
        return (
          <Box>
            {/* <AdminFeRoleMasterComponent
              title="FE AC Master"
              apiEndpoint="fe-ac"
              roleFieldName="ac"
              roleLabel="AC"
            /> */}

            <AdminFeAcMgmt />
          </Box>
        );

      case "AC":
        return (
          <Box>
            {/* <AdminFeRoleMasterComponent
            title="FE Tahsildar Master"
            apiEndpoint="fe-tahsildar"
            roleFieldName="tahsildar"
            roleLabel="Tahsildar"
          /> */}
            <AdminFETahsildarMgmt />
          </Box>
        );

      case "AD":
        return (
          <Box>
            {/* <AdminFeRoleMasterComponent
            title="FE Legal Master"
            apiEndpoint="fe-legal"
            roleFieldName="legal"
            roleLabel="Legal"
          /> */}
            <AdminFeLegalMgmt />
          </Box>
        );

      case "AE":
        return (
          <Box>
            {/* <AdminFeRoleMasterComponent
    title="FE JS Master"
    apiEndpoint="fe-js"
    roleFieldName="js"
    roleLabel="JS"
  /> */}

            <AdminFeJsmgmt />
          </Box>
        );

      // AdminFeVer2Component

      default:
        return <Typography variant="h6">Please select an option</Typography>;
    }
  };

  return (
    <Box sx={{ width: "100%", padding: 2 }}>
      <Box sx={{ width: 300 }}>
        <FormControl fullWidth>
          <InputLabel id="dropdown-label">Select Option</InputLabel>
          <Select
            labelId="dropdown-label"
            value={selectedOption}
            label="Select Option"
            onChange={handleChange}
          >
            <MenuItem value="A">FE Base Mgmt</MenuItem>
            <MenuItem value="B">FE Anual Reports</MenuItem>
            <MenuItem value="C">FE Bussiness Type</MenuItem>
            <MenuItem value="D">FE Charge Sheet</MenuItem>
            <MenuItem value="E">FE Anual Audit Reports</MenuItem>
            <MenuItem value="F">FE Bank Accounts</MenuItem>
            <MenuItem value="G">FE Business Premises</MenuItem>
            <MenuItem value="H">FE Capital Contribution</MenuItem>
            <MenuItem value="I">FE Codes Mgmt</MenuItem>
            <MenuItem value="J">FE Court Cases</MenuItem>
            <MenuItem value="K">FE Officials</MenuItem>
            <MenuItem value="L">FE Personal Properties</MenuItem>
            <MenuItem value="M">FE Property Holdings</MenuItem>
            <MenuItem value="N">FE Sibling Companies</MenuItem>
            <MenuItem value="O">FE Validity Mgmt</MenuItem>
            <MenuItem value="P">FE FIR</MenuItem>
            <MenuItem value="Q">FE Fraudulent Scheme</MenuItem>
            <MenuItem value="R">FE Docs Master</MenuItem>
            <MenuItem value="S">FE Legecy Data</MenuItem>
            <MenuItem value="T">FE CA Mgmt</MenuItem>
            <MenuItem value="U">FE Verifier 1 Mgmt</MenuItem>
            <MenuItem value="V">FE Verifier 2 Mgmt</MenuItem>
            <MenuItem value="W">FE Super Staff Mgmt</MenuItem>
            <MenuItem value="X">FE Sherastedar Mgmt</MenuItem>
            <MenuItem value="Y">Public Record User Mgmt</MenuItem>
            <MenuItem value="Z">Warrant User Mgmt</MenuItem>
            <MenuItem value="AA">Forensic Auditor Mgmt</MenuItem>
            <MenuItem value="AB">FE AC Mgmt</MenuItem>
            <MenuItem value="AC">FE Thahsildar Mgmt</MenuItem>
            <MenuItem value="AD">FE Legal Mgmt</MenuItem>
            <MenuItem value="AE">FE JS Mgmt</MenuItem>
          </Select>
        </FormControl>
      </Box>
      <Box sx={{ marginTop: 3, width: "100%" }}>{renderComponent()}</Box>
    </Box>
  );
};

export default FeMenuDropdownComponent;
